import { Fallback } from '@/modules/shared/components/fallback/Fallback'
import { Tooltip } from '@/modules/shared/components/tooltip/Tooltip'
import { QuestionMarkIcon } from '@/modules/shared/icons/QuestionMarkIcon'

export interface SimpleTableItemWithTooltipProps {
  title: string
  tooltip?: string
  value?: string | null | React.JSX.Element
  testId?: string
}

export const SimpleTableItemWithTooltip = ({ title, tooltip, value, testId }: SimpleTableItemWithTooltipProps) => (
  <div className="flex flex-col">
    <p className="flex items-center gap-x-1 font-bold" data-testid={testId}>
      {title}
      {tooltip && (
        <Tooltip content={tooltip}>
          <QuestionMarkIcon className="size-4" />
        </Tooltip>
      )}
    </p>

    <Fallback as="p" condition={!!value}>
      {value}
    </Fallback>
  </div>
)
